<template>
<div>
  <!-- Top navigation and information -->
  <div class="view-title">
    <div class="back-button">
      <div v-if="question > 1 && question < 4">
        <img
          src="@/assets/backarrow.svg"
          alt="back"
          height="30px"
          v-touch:tap="previousQuestion"/>
        <p>{{ $t('commons.back') }}</p>
      </div>
    </div>
    <p class="question-indication">{{ displayQuestionNumber() }}</p>
  </div>

  <!-- All questions views grouped -->
  <div class="survey-form-container">
    <div>

      <!-- QUESTION 1 -->
      <div
        class="select-area"
        :class="{'animate-question': startSurvey,
          'animate-question-leave': leave1,
          'hide-question': question!==1}"
          v-on:animationend="endAnim1">
        <p class="survey-question">
          1 - {{ $t('survey_form.select_the_manufacturing_order_concerned') }}
        </p>
        <label for="ManufacturingOrder">{{ $t('survey_form.manufacturing_order') }}</label>
        <select name="ManufacturingOrder" v-model="manufactureOrderSelected">
          <option
            v-for="(mo, i) in moList" :key="i"
            :value="mo">{{ mo }}</option>
        </select>
        <p class="next-btn" @click="nextQuestion">{{ $t('commons.next') }}</p>
      </div>

      <!-- QUESTION 2 -->
      <div
        class="select-area"
        :class="{'animate-question': question === 2,
          'animate-question-leave': leave2,
          'hide-question': question!==2}"
        v-on:animationend="endAnim2">
        <p class="survey-question">
          2 - {{ $t('survey_form.select_the_production_area_concerned') }}
        </p>
        <label for="ProductionArea">{{ $t('survey_form.production_area') }}</label>
        <select name="ProductionArea" v-model="productionAreaSelected">
          <option
            v-for="(pa, i) in productionArea" :key="i"
            :value="pa">{{ pa }}</option>
        </select>
        <p class="next-btn" @click="nextQuestion">{{ $t('commons.next') }}</p>
      </div>

      <!-- QUESTION 3 -->
      <div
        class="select-area"
        :class="{'animate-question': question === 3,
          'animate-question-leave': leave3,
          'hide-question': question!==3}"
          v-on:animationend="endAnim3">
        <div>
          <p class="survey-question">{{ $t('survey_form.final_survey_question') }}</p>
        </div>
        <div>
          <textarea
            class="final-text-area"
            :placeholder="$t('survey_form.enter_your_comment_here')"></textarea>
          <div @click="sendUserFeedBack">
            <app-button-rect :text="$t('survey_form.send')"></app-button-rect>
          </div>
        </div>
      </div>

      <!-- QUESTION 4 -->
      <div
        class="select-area"
        :class="{'animate-question': question === 4,
          'animate-question-leave': leave4,
          'hide-question': question!==4}"
        v-on:animationend="endAnim4">
        <div>
        </div>
        <div>
          <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
        </div>
      </div>

    </div>
  </div>
</div>
</template>

<script>
import ButtonRect from '../components/ButtonRect.vue';

export default {
  components: {
    'app-button-rect': ButtonRect,
  },
  data() {
    return {
      moList: ['', 'Aucun', 'of1', 'of2', 'of3', 'of4'],
      productionArea: ['', 'Stock', 'Découpe', 'Hydroformage', 'Ceintrage A'],
      question: 0,
      startSurvey: false,
      leave1: false,
      leave2: false,
      leave3: false,
      leave4: false,
      manufactureOrderSelected: '',
      productionAreaSelected: '',
    };
  },
  mounted() {
    this.startSurvey = true;
  },
  watch: {
    manufactureOrderSelected() {
      this.leave1 = true;
    },
    productionAreaSelected() {
      this.leave2 = true;
    },
    transitionWindow() {
      this.question = 1;
    },
  },
  computed: {
    transitionWindow() {
      return this.$store.getters.getTransitionWindow;
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    endAnim1(e) {
      if (e.animationName.indexOf('topToHide') >= 0) {
        this.question += 1;
      }
    },
    endAnim2(e) {
      if (e.animationName.indexOf('topToHide') >= 0) {
        this.question += 1;
      }
    },
    endAnim3(e) {
      if (e.animationName.indexOf('topToHide') >= 0) {
        this.question += 1;
      }
    },
    endAnim4(e) {
      if (e.animationName.indexOf('topToHide') >= 0) {
        this.question += 1;
      }
    },
    sendUserFeedBack() {
      // Should send all form to he server
      console.warn('WIP: Should Send the form to the server');
      this.leave3 = true;
    },
    displayQuestionNumber() {
      return this.question > 0 && this.question < 4 ? `${this.question} / 3` : ' ';
    },
    nextQuestion() {
      const firstQuestion = 1;
      const lastQuestion = 3;
      for (let i = firstQuestion; i < lastQuestion; i += 1) {
        if (this.question === i) {
          this[`leave${i}`] = true;
        }
      }
    },
    previousQuestion() {
      this.question -= 1;
      this.leave1 = false;
      this.leave2 = false;
      this.leave3 = false;
      this.leave4 = false;
    },
  },
};
</script>

<style scoped>
  .view-title {
    display: grid;
    grid-template-columns: 2fr 8fr 2fr;
    background-color: cornflowerblue;
    position: fixed;
    width: 100%;
    height: 60px;
  }

  .back-button {
    margin-top: 1vh;
    margin-bottom: 1vh;
  }

  .back-button > div > p {
    margin: 0;
    font-size: 12px;
    color: #ffffff;
    margin-top: -6px;
  }

  .survey-form-container {
    padding: 5%;
    padding-top: 0vh;
    display: flex;
    align-items: center;
    justify-content: center;
    height: -webkit-fill-available;
  }

  .select-area {
    text-align: left;
    margin-bottom: 2vh;
  }

  .animate-question {
    animation-name: bottomToTop;
    animation-duration: 0.6s;
  }

  @keyframes bottomToTop {
    0% {
      opacity: 0;
      margin-top: 100vh;
    }
    100% {
      opacity: 1;
      margin-top: 0vh;
    }
  }

  .animate-question-leave {
    animation-delay: 0.3s;
    animation-name: topToHide;
    animation-duration: 0.3s;
  }

  @keyframes topToHide {
    0% {
      opacity: 1;
      margin-top: 0vh;
    }
    100% {
      opacity: 0;
      margin-top: -25vh;
    }
  }

  /******************************************************************
  *                     CUSTOM FORM ELEMENT                         *
  ******************************************************************/

  select {
    -webkit-appearance: button;
    -moz-appearance: button;
    -webkit-user-select: none;
    -moz-user-select: none;
    -webkit-padding-end: 20px;
    -moz-padding-end: 20px;
    -webkit-padding-start: 2px;
    -moz-padding-start: 2px;
    background-color: #ffffff;
    background-position: center right;
    background-repeat: no-repeat;
    border: 1px solid #AAA;
    border-radius: 2px;
    box-shadow: 0px 1px 3px rgba(204, 165, 165, 0.1);
    color: #555;
    font-size: inherit;
    margin: 0;
    overflow: hidden;
    padding-top: 2px;
    padding-bottom: 2px;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    width: 100%;
    height: 50px;
    padding: 10px;
  }


  textarea {
    border: 1px solid grey;
    padding: 2vh;
    outline: none;
    margin-bottom: 2vh;
  }

  .final-text-area {
    width: -webkit-fill-available;
    min-height: 150px;
  }

  .survey-question {
    font-size: 1.2em;
    font-weight: 500;
  }

  .hide-question {
    opacity: 0;
    display: none;
  }

  .question-indication {
    color: #ffffff;
    font-weight: 500;
  }

  .next-btn {
    text-align: right;
  }

  /******************************************************************
  *                      CIRCLE CHECK MARK                          *
  *******************************************************************/

  /* Circle loader with checkmark completed state: by https://codepen.io/scottloway/pen/zqoLyQ */
  .checkmark__circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke: #7ac142;
    fill: none;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
  }

  .checkmark {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    display: block;
    stroke-width: 2;
    stroke: #fff;
    stroke-miterlimit: 10;
    margin: 10% auto;
    box-shadow: inset 0px 0px 0px #7ac142;
    animation: fill .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
  }

  .checkmark__check {
    transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
  }

  @keyframes stroke {
    100% {
      stroke-dashoffset: 0;
    }
  }
  @keyframes scale {
    0%, 100% {
      transform: scale3d(2.1, 2.1, 1);
    }
    50% {
      transform: scale3d(3.1, 3.1, 1);
    }
  }
  @keyframes fill {
    100% {
      box-shadow: inset 0px 0px 0px 30px #7ac142;
    }
  }

</style>
